import axios from "axios";
import { baseURL } from "@/general";


const adminApi = axios.create({
  baseURL,
});

//Investigador
export const getInvestigators = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get(
      "/investigador/getInvestigadores",
      config
    );
    return response;
  } catch (error) {
    const response = {};
    return response;
  }
};

export const insertInvestigator = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/investigador/registroInvestigador",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateInvestigator = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/investigador/updateInvestigador",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const deleteInvestigator = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/investigador/deleteInvestigador",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const validaRFC = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/investigador/validaRFC",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

///Semestres
export const getSemestres = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get("/semestre/getSemestre", config);
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

export const insertSemestres = async (datos) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/semestre/insertSemestre",
      datos,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateSemestres = async (datos) => {
  let token = localStorage.getItem("session_id");

  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/semestre/updateSemestre",
      datos,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

///Estancias
export const getEstancias = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get("/estancia/getEstancias", config);
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

export const borraEstancia = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post("/estancia/delete", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const revisarEstancia = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/estancia/aprobarEstancia",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Alumnos
export const insertaAlumno = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/insertAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const actualizaAlumno = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/updateAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const aceptaRechazaAlumnos = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "investigador/revisarAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const revisarDocumentacion = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "alumno/revisarDocumentos",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};



export const insertaAlumnoBachillerato = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/insertAlumnoBachillerato",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const insertaAlumnoBachilleratoIndividual = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/insertAlumnoBachilleratoIndividual",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};




export const getAlumnoLicenciatura = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get(
      "/alumno/getAlumnoLicenciatura",
      config
    );
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

export const getAlumnoBachillerato = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get(
      "/alumno/getAlumnosBachillerato",
      config
    );
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

export const validaCuenta = async (cuenta, idTipoAlumno) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/validaCuenta",
      {
        cuenta,
        idTipoAlumno,
      },
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const deleteAlumno = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/deleteAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateAlumno = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/updateAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const aprobarInforme = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/aprobarInformeFinal",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error.response;
    return response.response.data;
  }
};


export const reporteEstanciasRegistradas = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/estanciasRegistradas",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};


export const reporteEstanciasLicenciatura = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/estanciasLicenciatura",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};


export const reporteEstanciasBachillerato = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/estanciasBachillerato",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};


export const reporteAlumnosLicenciatura = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/alumnosLicenciatura",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};


export const reporteAlumnosBachillerato = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/alumnosBachillerato",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};

export const reporteEncuesta = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/encuestaAlumno",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};

export const reporteEvaluciones = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/evaluacionInvestigador",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};

export const documentacionLicenciatura = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/documentacionLicenciatura",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};

export const firmasLicenciatura = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/firmasLicenciatura",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};

export const entregaCartelLicenciatura = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/entregaCartelLicenciatura",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};


export const documentacionBachillerato = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/reporte/documentacionBachillerato",values,      
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};



